import _axios from "@/axios";
import { ref, reactive } from "@vue/composition-api";

const activesessions = ref({});

export function useActiveSession() {
  let data = reactive({
    options: {},
    firstLoad: true,
    isLoading: false,
  });

  function listClientActiveSessions(clientId = null) {
    let routePath = "";
    if (clientId != null) {
      routePath = "/list-active-session/portal/" + clientId;
    }

    listActiveSessions(routePath);
  }

  function listCardActiveSessions(cardId = null) {
    let routePath = "";
    if (cardId != null) {
      routePath = "/list-active-session/card/" + cardId;
    }

    listActiveSessions(routePath);
  }

  function listActiveSessions(routePath) {
    data.isLoading = true;

    const params = new URLSearchParams();

    params.set("page", data.options.page ?? 1);
    params.set("itemsPerPage", data.options.itemsPerPage ?? 10);

    if (data.options.sortBy && data.options.sortBy.length > 0) {
      if (data.options.sortDesc[0]) {
        params.set("order[desc]", data.options.sortBy[0]);
      } else {
        params.set("order[asc]", data.options.sortBy[0]);
      }
    } else {
      params.set("order[asc]", "sessionStartsAt");
    }

    return _axios
      .get(routePath + "?" + params.toString())
      .then((response) => {
        activesessions.value = response.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      })
      .finally(() => {
        data.isLoading = false;
        data.firstLoad = false;
      });
  }

  return {
    activesessions,
    listClientActiveSessions,
    listCardActiveSessions,
    data,
  };
}
